export const EMPTY_FORM = {
  title: "",
  description: "",
  research_methodology: "",
  source_link: "",
  note: "",
  date: "",
  start_date: "",
  end_date: "",
  year: "",
};

// ISO date -> value for <input type="date">
export const toInputDate = (d) => (d ? new Date(d).toISOString().slice(0, 10) : "");

// dataset row from API -> form state
export const rowToForm = (row = {}) => ({
  title: row.title || "",
  description: row.description || "",
  research_methodology: row.research_methodology || "",
  source_link: row.source_link || "",
  note: row.note || "",
  date: toInputDate(row.date),
  start_date: toInputDate(row.date_range?.start_date),
  end_date: toInputDate(row.date_range?.end_date),
  year: row.year ?? "",
});

// returns an error message, or null if valid
export const validateForm = (form) => {
  if (!form.title.trim()) return "Title is required";

  if (form.year !== "") {
    const y = Number(form.year);
    if (!Number.isInteger(y) || y < 1900 || y > 2100) return "Year must be between 1900 and 2100";
  }

  if (form.start_date && form.end_date && form.start_date > form.end_date) {
    return "Start date cannot be after end date";
  }

  if (form.source_link.trim() && !/^https?:\/\/\S+$/i.test(form.source_link.trim())) {
    return "Source link must start with http:// or https://";
  }

  return null;
};

// form state -> API payload (empty values go as null so they can be cleared)
export const buildPayload = (form) => ({
  title: form.title.trim(),
  description: form.description.trim() || null,
  research_methodology: form.research_methodology.trim() || null,
  source_link: form.source_link.trim() || null,
  note: form.note.trim() || null,
  date: form.date || null,
  date_range: {
    start_date: form.start_date || null,
    end_date: form.end_date || null,
  },
  year: form.year === "" ? null : Number(form.year),
});

export const formatDate = (d) =>
  d
    ? new Date(d).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" })
    : "-";